import { render } from "./InventoryCount.vue?vue&type=template&id=67a7fa34"
import script from "./InventoryCount.vue?vue&type=script&lang=js"
export * from "./InventoryCount.vue?vue&type=script&lang=js"
script.render = render

export default script